/**
 * 前端老屋都更／危老重建潛力空間圖層控制模組 (Urban Renewal Map Layer)
 * 版本：v1.0.0-Beta
 */

let urbanLayerGroup = null;
let isLoading = false;

export function initUrbanRenewalLayer(map) {
    const toggleEl = document.getElementById('toggle-urban-renewal-layer');
    const statusEl = document.getElementById('urban-renewal-status');
    if (!toggleEl || !map) return;

    urbanLayerGroup = L.layerGroup();

    toggleEl.addEventListener('change', async (e) => {
        if (e.target.checked) {
            if (isLoading) return;
            isLoading = true;
            if (statusEl) statusEl.textContent = '載入中...';

            try {
                // 依當前地圖視窗邊界查詢
                const bounds = map.getBounds();
                const bbox = `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`;
                const res = await fetch(`/api/urban-renewal/layer?bbox=${encodeURIComponent(bbox)}&min_age=25`);
                const data = await res.json();

                urbanLayerGroup.clearLayers();

                if (!data.features || data.features.length === 0) {
                    if (statusEl) statusEl.textContent = '範圍內無物件';
                    map.addLayer(urbanLayerGroup);
                    isLoading = false;
                    return;
                }

                data.features.forEach(feat => {
                    const [lng, lat] = feat.geometry.coordinates;
                    const p = feat.properties;

                    const marker = L.circleMarker([lat, lng], {
                        radius: p.danger_level === 'critical_40' ? 7 : (p.danger_level === 'danger_30' ? 6 : 5),
                        fillColor: p.color,
                        color: '#ffffff',
                        weight: 1.5,
                        opacity: 0.9,
                        fillOpacity: 0.85
                    });

                    const popupContent = `
                        <div style="font-family: system-ui, sans-serif; min-width: 220px; font-size: 13px; line-height: 1.4; color: #1e293b;">
                            <div style="font-size: 14px; font-weight: bold; margin-bottom: 4px; color: #0f172a; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px;">
                                ${escapeHtml(p.name)}
                            </div>
                            <div style="display: flex; gap: 6px; margin: 4px 0;">
                                <span style="background: ${p.color}; color: #fff; font-size: 11px; padding: 2px 6px; border-radius: 4px; font-weight: bold;">
                                    ${escapeHtml(p.level_label)}
                                </span>
                                <span style="background: #f1f5f9; color: #475569; font-size: 11px; padding: 2px 6px; border-radius: 4px;">
                                    ${escapeHtml(p.type_label)}
                                </span>
                            </div>
                            <div style="margin-top: 6px; font-size: 12px;">
                                <strong>使照字號：</strong>${escapeHtml(p.license_usage || '無')}<br>
                                ${p.permit_no ? `<strong>建照字號：</strong>${escapeHtml(p.permit_no)}<br>` : ''}
                                <strong>使照年份：</strong>民國 ${p.roc_year} 年 (法定屋齡約 ${p.building_age} 年)<br>
                                <strong>門牌地址：</strong>${escapeHtml(p.address || (p.county + p.district))}<br>
                            </div>
                            <div style="margin-top: 8px; font-size: 10px; color: #94a3b8; border-top: 1px dashed #e2e8f0; padding-top: 4px;">
                                ⚠️ 測試功能僅供參考，法規依各地方自治規定。
                            </div>
                        </div>
                    `;

                    marker.bindPopup(popupContent);
                    urbanLayerGroup.addLayer(marker);
                });

                map.addLayer(urbanLayerGroup);
                if (statusEl) statusEl.textContent = `已載入 ${data.features.length} 棟`;
            } catch (err) {
                console.error('[UrbanRenewal] 圖層載入失敗:', err);
                if (statusEl) statusEl.textContent = '載入失敗';
            } finally {
                isLoading = false;
            }
        } else {
            if (urbanLayerGroup) {
                map.removeLayer(urbanLayerGroup);
                urbanLayerGroup.clearLayers();
            }
            if (statusEl) statusEl.textContent = '已關閉';
        }
    });

    // 地圖平移縮放時，若開關有開啟，提示重新載入
    map.on('moveend', () => {
        if (toggleEl.checked && !isLoading) {
            toggleEl.dispatchEvent(new Event('change'));
        }
    });
}

function escapeHtml(str) {
    if (!str) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
